/*
 * 暫定対応: 複数販売店(vendor)混在カートのチェックアウト制御
 *
 * カート内の商品(vendor)が2種類以上になっている場合、通常のチェックアウトボタンを
 * disabled にし、警告文をボタン直前に表示する。撤去する際は layout/theme.liquid に
 * 追加した script 読み込み行と、このファイルを削除すればよい。
 *
 * 実テーマのチェックアウトボタンのセレクタが下記と異なる場合はここに追記する。
 */
(function () {
  'use strict';

  var CHECKOUT_SELECTOR = '[name="checkout"], .cart__checkout-button';
  var WARNING_CLASS = 'cart__subtotal__cancellationNote';
  var WARNING_MARKER = 'data-multi-vendor-checkout-warning';
  var WARNING_TEXT =
    'カート内に複数の販売店の商品が含まれているため、このままではご購入手続きに進めません。お手数ですが、販売店ごとにご注文をお分けください。';

  function getDistinctVendorCount(cart) {
    var vendors = {};
    (cart.items || []).forEach(function (item) {
      if (item.vendor) {
        vendors[item.vendor] = true;
      }
    });
    return Object.keys(vendors).length;
  }

  // WARNING_CLASS は既存テーマの静的な注意書き(snippets/cart.liquid内)と同じ
  // クラス名のため、挿入済みかどうかの判定にクラス名は使えない(既存要素と誤認して
  // 二重挿入防止ロジックが常にスキップしてしまう)。挿入した要素は WARNING_MARKER
  // (表示に影響しない内部管理用の data 属性)で識別する。
  //
  // ボタン要素自体がテーマ側の他スクリプトによって再生成/移動される可能性があるため、
  // JSオブジェクトの同一性(WeakMap等)に頼らず、毎回 button.parentNode を実DOMから
  // 検索し直す。既に複数の警告文が存在していた場合も余剰分をここで必ず除去し、
  // 常に0個または1個の状態に自己修復する。
  function insertWarning(button) {
    if (!button || !button.parentNode) return;
    var existing = button.parentNode.querySelectorAll('[' + WARNING_MARKER + ']');
    if (existing.length > 0) {
      for (var i = 1; i < existing.length; i++) existing[i].remove();
      return;
    }
    var warning = document.createElement('p');
    warning.className = WARNING_CLASS;
    warning.setAttribute(WARNING_MARKER, '');
    warning.textContent = WARNING_TEXT;
    button.parentNode.insertBefore(warning, button);
  }

  function removeWarning(button) {
    if (!button || !button.parentNode) return;
    button.parentNode.querySelectorAll('[' + WARNING_MARKER + ']').forEach(function (warning) {
      warning.remove();
    });
  }

  function applyState(isBlocked) {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (button) {
      if (isBlocked) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        insertWarning(button);
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        removeWarning(button);
      }
    });
  }

  function checkCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        applyState(getDistinctVendorCount(cart) > 1);
      })
      .catch(function () {
        // 通信エラー時は既存の購入導線を阻害しない
      });
  }

  // ドロワー等でボタンが再描画され disabled 属性が失われた場合の保険として、
  // クリック時点でも disabled 状態を再チェックする。
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest(CHECKOUT_SELECTOR);
      if (!button) return;
      if (button.hasAttribute('disabled')) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  // カートドロワーの中身が AJAX で再描画されるケースに追従するための監視。
  var scheduled = null;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = window.setTimeout(function () {
      scheduled = null;
      checkCart();
    }, 300);
  });

  function init() {
    checkCart();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', checkCart);
})();
